// Single access point for Vite build-time environment variables.
//
// Tests set these via `test.env` in vite.config.ts so the real module runs
// under Vitest without a separate stub. A release build sets VITE_APP_VERSION
// to the image tag. Locally that variable is unset, so the menu shows "dev".
const localVersion = "dev";

export const API_BASE_URL: string = import.meta.env.VITE_API_BASE_URL;
export const AZURE_CLIENT_ID: string = import.meta.env.VITE_AZURE_CLIENT_ID;
export const AZURE_TENANT_ID: string = import.meta.env.VITE_AZURE_TENANT_ID;
export const AZURE_REDIRECT_URI: string = import.meta.env
  .VITE_AZURE_REDIRECT_URI;
export const APP_VERSION: string =
  import.meta.env.VITE_APP_VERSION || localVersion;
